(function ($, Drupal) {
  Drupal.behaviors.infiniteResultsCounter = {
    attach: function (context, settings) {
      $(document).ready(function() {
        if ($('.view-search-results .views-row').length && $('.results-loaded').length) {
          var searchResults = $('.view-search-results .views-row').length;
          $('.results-loaded').html(searchResults);
        }
      });
    }
  };

})(jQuery, Drupal);